module.exports = __webpack_public_path__ + "624c1255/img/79000000-4.1371079b.png";